var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgKeyIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Iconly_Bulk_Password",
    "data-name": "Iconly/Bulk/Password",
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.53,
    height: 9.2,
    viewBox: "0 0 19.53 9.2",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Password",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Combined_Shape",
    "data-name": "Combined Shape",
    d: "M18.26,9.2a1.287,1.287,0,0,1-1.271-1.328V5.926H14.737V7.872A1.3,1.3,0,0,1,13.466,9.2,1.286,1.286,0,0,1,12.2,7.872V5.926H8.6A4.377,4.377,0,0,1,4.421,9.2,4.518,4.518,0,0,1,0,4.6,4.518,4.518,0,0,1,4.421,0,4.377,4.377,0,0,1,8.6,3.274H18.26A1.3,1.3,0,0,1,19.53,4.6V7.872A1.3,1.3,0,0,1,18.26,9.2ZM4.421,2.654A1.916,1.916,0,0,0,2.541,4.6a1.916,1.916,0,0,0,1.88,1.946A1.908,1.908,0,0,0,6.284,4.6,1.908,1.908,0,0,0,4.421,2.654Z",
    transform: "translate(0 0)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKeyIcon);
export default __webpack_public_path__ + "static/media/key-icon.0f0ac5d8884d5ff768946ffb437ac2dd.svg";
export { ForwardRef as ReactComponent };